import { post } from './requests'

export const sendOnePaymentData = (key, id, payload) =>
  post(['loans', id, 'payment-accept'], { key, transformPayload: true }, payload)

export const disconnectAutoPay = (key, id, payload) =>
  post(['loans', id, 'remove-autopay'], { key, transformPayload: true }, payload)
